(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-sec"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var faqItems = document.querySelectorAll('.faq-item .faq-question');

  // Open the first accordion by default
  if (faqItems.length > 0) {
    faqItems[0].classList.add('active');
    var firstAnswer = faqItems[0].nextElementSibling;
    if (firstAnswer) {
      firstAnswer.style.display = "block";
    }
  }

  faqItems.forEach(function(item) {
    item.addEventListener('click', function() {
      // Close all other accordions
      faqItems.forEach(function(otherItem) {
        if (otherItem !== item) {
          otherItem.classList.remove('active');
          var otherAnswer = otherItem.nextElementSibling;
          if (otherAnswer) {
            otherAnswer.style.display = "none";
          }
        }
      });

      // Toggle the clicked accordion
      this.classList.toggle('active');
      var answer = this.nextElementSibling;
      if (answer.style.display === "block") {
        answer.style.display = "none";
      } else {
        answer.style.display = "block";
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["high-frequency-mobile"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.swiper-container', {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true,
        },
        draggable: true,
        loop: true, // Optional: enables continuous loop mode
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technology-behind"] && !Shopify.designMode) return;
  try {
    
 var swiper = new Swiper('.tech-slider', {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  } catch(e) { console.error(e); }
})();
})();
